// Importable from the frontend — no LaunchDarkly client or backend-only deps.

export type AgentsTier = "off" | "free" | "full";

/**
 * Resolve the effective agents tier from the `dataAgents` LD flag value.
 *
 * Pass the raw string (or `undefined`/`null` if the flag isn't available). A
 * known `AgentsTier` is returned as-is; anything else — including `undefined`,
 * `null`, or an unexpected string — resolves to "off".
 */
export function resolveAgentsTier(
  dataAgents: string | null | undefined,
): AgentsTier {
  if (dataAgents === "off" || dataAgents === "free" || dataAgents === "full") {
    return dataAgents;
  }
  return "off";
}

const TIER_RANK: Record<AgentsTier, number> = { off: 0, free: 1, full: 2 };

export function maxAgentsTier(a: AgentsTier, b: AgentsTier): AgentsTier {
  return TIER_RANK[a] >= TIER_RANK[b] ? a : b;
}

export function isAgentsEnabled(tier: AgentsTier): boolean {
  return tier !== "off";
}

export function isFullAgents(tier: AgentsTier): boolean {
  return tier === "full";
}
